import URL from '@/creditflowresearch/Router/urlConstants';

const getProductAbbreviationByPath = (pathname: string): string => {
  const pathToAbbreviation: Record<string, string> = {
    [URL.MARKET_OVERVIEW_HYC]: 'HYC',
    [URL.MARKET_OVERVIEW_IGC]: 'IGC',
  };

  return pathToAbbreviation[pathname] || 'ABS';
};

export default getProductAbbreviationByPath;
